import React from 'react'
import { mockSuggestions } from '../data/mockSuggestionsData'

const TestSuggestions: React.FC = () => {
  console.log('Test page - mockSuggestions:', mockSuggestions)
  
  return (
    <div style={{ padding: '20px' }}>
      <h1>Test Suggestions Page</h1>
      <div>
        <h2>Raw Data Check:</h2>
        <p>Number of suggestions loaded: {mockSuggestions ? mockSuggestions.length : 'NONE'}</p>
        
        {mockSuggestions && mockSuggestions.length > 0 ? (
          <div>
            <h3>First suggestion:</h3>
            <pre>{JSON.stringify(mockSuggestions[0], null, 2)}</pre>
            
            <h3>All Headlines:</h3>
            <ul>
              {mockSuggestions.map((s, i) => (
                <li key={i}>{s.headline || 'NO HEADLINE'}</li>
              ))}
            </ul>
          </div>
        ) : (
          <div style={{ color: 'red', fontSize: '20px' }}>
            NO DATA LOADED - mockSuggestions is {mockSuggestions === undefined ? 'undefined' : mockSuggestions === null ? 'null' : 'empty array'}
          </div>
        )}
      </div>
    </div>
  )
}

export default TestSuggestions